/* eslint-disable */
import React, { useState } from 'react';
import '../styles/NewsSection.css';

import image12 from '../../../assets/images/image12.png'
import image8 from '../../../assets/images/image17.png'

const NewsSection = ({ currentPage, setCurrentPage }) => {
    const [setIsMobileMenuOpen] = useState(false);
  const featuredNews = [
    {
      id: 1,
      title: 'World One Health Day Celebration 2024',
      excerpt: 'Join us in commemorating the International One Health Day with community engagement activities and awareness campaigns across South Sudan.',
      date: '2024-11-03',
      image: image12,
      category: 'Event',
      readTime: '3 min read',
      featured: true
    },
    {
      id: 2,
      title: 'New Anthrax Situation Report Released',
      excerpt: 'Latest surveillance data shows significant progress in anthrax prevention and control measures in affected regions.',
      date: '2024-10-28',
      image: image8,
      category: 'Report',
      readTime: '2 min read',
      featured: true
    },
    {
      id: 3,
      title: 'Surge Capacity Training Program Launched',
      excerpt: 'Intensive training initiative for rapid response teams to enhance emergency preparedness across all states.',
      date: '2024-10-15',
      image: '/assets/news-training.jpg',
      category: 'Training',
      readTime: '4 min read',
      featured: false
    },
    {
      id: 4,
      title: 'Zoonotic Disease Research Breakthrough',
      excerpt: 'New research findings provide insights into disease transmission patterns between animals and humans.',
      date: '2024-10-08',
      image: '/assets/news-research.jpg',
      category: 'Research',
      readTime: '5 min read',
      featured: false
    }
  ];

  const upcomingEvents = [
    {
      id: 1,
      title: 'One Health Technical Working Group Meeting',
      date: '2024-11-20',
      time: '10:00 AM',
      location: 'Ministry of Health HQ',
      type: 'Meeting'
    },
    {
      id: 2,
      title: 'Emergency Response Simulation Exercise',
      date: '2024-11-25',
      time: '8:00 AM',
      location: 'Juba Training Center',
      type: 'Training'
    },
    {
      id: 3,
      title: 'Community Health Awareness Campaign',
      date: '2024-12-05',
      time: '9:00 AM',
      location: 'Various Counties',
      type: 'Outreach'
    }
  ];

  return (
    <section className="news-section">
      <div className="container">
        <div className="news-header">
          <h2>Latest News & Updates</h2>
          <p>Stay informed with the latest developments in health security and One Health initiatives</p>
          <button className="view-all-btn"
            onClick={() => {
              setCurrentPage('news');
              setIsMobileMenuOpen(false);
              }}
          >View All News</button>
        </div>

        <div className="news-content">
          <div className="featured-news">
            <h3>Featured Stories</h3>
            <div className="featured-grid">
              {featuredNews.filter(news => news.featured).map(news => (
                <article key={news.id} className="featured-card">
                  <div className="news-image">
                    <img src={news.image} alt={news.title} />
                    <div className="news-badge">{news.category}</div>
                  </div>
                  <div className="news-content">
                    <div className="news-meta">
                      <span className="news-date">
                        {new Date(news.date).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric'
                        })}
                      </span>
                      <span className="read-time">{news.readTime}</span>
                    </div>
                    <h4 className="news-title">{news.title}</h4>
                    <p className="news-excerpt">{news.excerpt}</p>
                    <button className="read-more-btn">Read Full Story →</button>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {/* Sidebar with Recent News and Events */}
          <div className="news-sidebar">
            {/* Recent News List */}
            <div className="recent-news">
              <h4>Recent Updates</h4>
              <div className="news-list">
                {featuredNews.filter(news => !news.featured).map(news => (
                  <div key={news.id} className="recent-news-item">
                    <div className="recent-content">
                      <h5>{news.title}</h5>
                      <div className="recent-meta">
                        <span>{new Date(news.date).toLocaleDateString()}</span>
                        <span>{news.category}</span>
                      </div>
                    </div>
                    <button className="quick-read-btn">→</button>
                  </div>
                ))}
              </div>
            </div>

            {/* Upcoming Events */}
            <div className="upcoming-events">
              <h4>Upcoming Events</h4>
              <div className="events-list">
                {upcomingEvents.map(event => (
                  <div key={event.id} className="event-item">
                    <div className="event-date">
                      <div className="event-day">
                        {new Date(event.date).getDate()}
                      </div>
                      <div className="event-month">
                        {new Date(event.date).toLocaleDateString('en-US', { month: 'short' })}
                      </div>
                    </div>
                    <div className="event-details">
                      <h5>{event.title}</h5>
                      <div className="event-meta">
                        <span>🕒 {event.time}</span>
                        <span>📍 {event.location}</span>
                      </div>
                      <span className="event-type">{event.type}</span>
                    </div>
                  </div>
                ))}
              </div>
              <button className="view-calendar-btn">View Full Calendar</button>
            </div>

            {/* Newsletter Signup */}
            <div className="newsletter-sidebar">
              <div className="newsletter-icon">📧</div>
              <h4>Stay Updated</h4>
              <p>Subscribe to our monthly One Health bulletin</p>
              <div className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="newsletter-input"
                />
                <button className="subscribe-btn">Subscribe</button>
              </div>
            </div>
          </div>
        </div>

        <div className="news-stats">
          <div className="stat-item">
            <div className="stat-number">50+</div>
            <div className="stat-label">News Articles Monthly</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">15+</div>
            <div className="stat-label">Events Organized</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">10K+</div>
            <div className="stat-label">Monthly Readers</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">25+</div>
            <div className="stat-label">Media Partners</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;